import React from "react";
import { Button, Tag } from "antd";
import { EnvironmentOutlined } from "@ant-design/icons";
import type { Market } from "types/market";
import martEmptyImg from "assets/images/mart-empty.png";

export type MartCardProps = {
  mart: Market;
  onView: (id: number) => void;
  onEdit: (id: number) => void;
  onDeleteRequest: (id: number) => void;
  onViewStores: (id: number) => void;
};

export const MartCard: React.FC<MartCardProps> = ({
  mart,
  onView,
  onEdit,
  onDeleteRequest,
  onViewStores,
}) => {
  const isUpcoming = mart.status === "upcoming";

  return (
    <div className="market-card">
      <div className="market-card-logo">
        <img
          src={mart.logo || martEmptyImg}
          alt={mart.name}
          className="market-card-logo-img"
          onError={(event) => {
            if (!event.currentTarget.src.endsWith(martEmptyImg)) {
              event.currentTarget.src = martEmptyImg;
            }
          }}
        />
      </div>

      <div className="market-card-body">
        <div className="market-card-info">
          <div className="market-card-title-row">
            <div className="market-card-name">{mart.name}</div>
            <Tag
              color={isUpcoming ? "warning" : "success"}
              className="market-card-status-tag"
            >
              {isUpcoming ? "Upcoming" : "Active"}
            </Tag>
          </div>
          <div className="market-card-location">
            <EnvironmentOutlined className="market-card-pin" />
            {mart.location}
          </div>
          <div className="market-card-description">{mart.description}</div>
        </div>

        <div className="market-card-actions">
          <Button
            type="text"
            size="small"
            className="market-card-btn-view"
            onClick={() => onView(mart.id)}
          >
            View
          </Button>
          <Button
            type="text"
            size="small"
            className="market-card-btn-view"
            onClick={() => onViewStores(mart.id)}
          >
            View Stores
          </Button>
          <Button
            type="text"
            size="small"
            className="market-card-btn-edit"
            onClick={() => onEdit(mart.id)}
          >
            Edit
          </Button>
          <Button
            type="text"
            size="small"
            className="market-card-btn-delete"
            onClick={() => onDeleteRequest(mart.id)}
          >
            Delete
          </Button>
        </div>
      </div>
    </div>
  );
};

export default MartCard;
